export const SAVED_RETURNED_ENDPOINT = '/api/savedReturned'
